
import { Vue, Options } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { maska } from 'maska'
import {
  IAppUser,
  IFlexAnswer,
  IFlexMessageBubble,
  IFlexMessageCarousel,
  IInitialCampaign,
  IPushCampaign,
  ISendingTestRequest,
  IStory,
  IUser,
} from '@/utils/types'
import { CAMPAIGN_TYPE, constant } from '@/utils/constants'
import { ACTION_APP_USER, ACTION_STORY } from '@/store/actions'
import UserAvatar from '@/components/user/UserAvatar.vue'
import CLoading from '@/components/common/ui/CLoading.vue'

@Options({
  components: { UserAvatar, CLoading },
  directives: { maska },
  emits: ['update:closeModal', 'update:onSelect'],
})
export default class SendingTestModal extends Vue {
  @Prop()
  modalVisible!: boolean

  @Prop()
  story!: IStory

  @Prop()
  flexJson!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  scenario!: IInitialCampaign | IPushCampaign

  @Prop()
  campaignType!: string

  @Prop()
  isFlex!: boolean

  @Prop()
  msg!: string

  @Prop()
  msgTestMode!: string

  @Prop()
  appID!: string

  loading = false
  step = 1
  value = 0
  pushIndex = 0
  isTestMode = true
  selectedUsers: IAppUser[] = []

  lineUsers = []
  pagination = {
    sortBy: '',
    descending: false,
    page: 1,
    rowsPerPage: constant.ROW_PER_PAGE,
    rowsNumber: 10,
  }

  columns = [{ name: 'display_name', label: 'display_name', field: 'display_name', align: 'left' }]

  get pushName() {
    if (this.story.pushes) {
      return this.story.pushes[this.pushIndex].title
    }
    return ''
  }

  get visible() {
    return this.modalVisible
  }

  set visible(value) {
    this.$emit('update:closeModal', value)
  }

  get rowPerPageOptions() {
    return constant.ROW_PER_PAGE_OPTIONS
  }

  @Watch('isTestMode', { immediate: true })
  async onChangeIsTestMode() {
    this.selectedUsers = []
  }

  selectPush(index: number) {
    this.value = 4
    this.pushIndex = index
  }

  onCancel() {
    this.visible = false
  }

  getUserInfo(display_name, picture_url) {
    const u: IUser = {
      photo_url: picture_url,
      display_name: display_name,
    }
    return u
  }

  async onRequest(props) {
    this.loading = true
    const { page, rowsPerPage } = props.pagination
    const returnedData = await this.fetchFromServer(page, rowsPerPage)
    if (returnedData) {
      // eslint-disable-next-line
      const items: [] = returnedData['items']
      this.lineUsers.splice(0, this.lineUsers.length, ...items)
      // eslint-disable-next-line
      this.pagination.rowsNumber = returnedData['total_items']
    }
    this.pagination.page = page
    this.pagination.rowsPerPage = rowsPerPage
    this.loading = false
  }

  async fetchFromServer(page, rowsPerPage) {
    const items = await this.$store.dispatch(ACTION_APP_USER.LOAD_ITEMS, {
      app_id: this.appID,
      is_test_mode: this.isTestMode,
      filter: {
        page: page,
        per_page: rowsPerPage,
      },
    })

    return items
  }

  onPrev() {
    this.step--
    this.lineUsers = []
    if (this.step === 3) {
      this.$nextTick(() => {
        // get initial data from server (1st page)
        this.$refs.tableRef.requestServerInteraction()
      })
    }
  }

  onNext() {
    if (this.step === 1) {
      if (this.value === 0) {
        this.$q.dialog({
          title: this.$t('error'),
          message: 'Please choose scenario!',
          persistent: true,
          html: true,
        })
        return
      }
    } else if (this.step === 3) {
      if (this.selectedUsers.length === 0) {
        this.$q.dialog({
          title: this.$t('error'),
          message: 'Please choose users!',
          persistent: true,
          html: true,
        })
        return
      }
    }
    this.lineUsers = []
    this.step++
    if (this.step === 3) {
      this.$nextTick(() => {
        // get initial data from server (1st page)
        this.$refs.tableRef.requestServerInteraction()
      })
    }
  }

  async onSend() {
    this.loading = true
    let initial_id = ''
    let push_id = ''
    const user_ids: string[] = []
    this.selectedUsers.forEach((element) => {
      user_ids.push(element.user_id ?? '')
    })

    const payload: ISendingTestRequest = {
      app_id: this.appID,
      is_test_mode: this.isTestMode,
      user_ids: user_ids,
      is_flex: this.isFlex,
      text_msg: this.msg,
    }
    if (this.isTestMode && this.msgTestMode !== '') {
      payload.text_msg = this.msgTestMode
    }

    if (this.isFlex) {
      if (!payload.text_msg) {
        const flex_answer: IFlexAnswer = {
          contents: this.flexJson,
        }
        payload.flex_answer = flex_answer
      }
    } else {
      if (this.story) {
        console.log(this.story, 'onSend story')
        payload.story_id = this.story._id
        if (this.value === 3) {
          initial_id = this.story.initial?._id ?? ''
          payload.initial_id = initial_id
        } else {
          if (this.story.pushes) {
            push_id = this.story.pushes[this.pushIndex]._id ?? ''
            payload.push_id = push_id
          }
        }
      } else if (this.scenario) {
        console.log(this.scenario, 'onSend scenario')
        console.log(this.campaignType, 'onSend campaignType')

        if (this.campaignType === CAMPAIGN_TYPE.INITIAL) {
          payload.initial_id = this.scenario._id
        } else {
          payload.push_id = this.scenario._id
        }
      }
    }

    const { dispatch } = this.$store
    const success = await dispatch(ACTION_STORY.SENDING_TEST, payload)
    console.log(success, 'onSend')
    this.loading = false
    if (success) {
      this.step++
    }
  }

  created() {
    if (this.isFlex || this.scenario) {
      this.step = 2
    }
  }
}
